// import HighchartsReact, {
//   HighchartsReactRefObject,
// } from 'highcharts-react-official';
// import Highcharts from 'highcharts';
// import HighchartsExporting from 'highcharts/modules/exporting';
// import HighchartsExportData from 'highcharts/modules/export-data';
import { useEffect, useRef } from 'react';
// HighchartsExporting(Highcharts);
// HighchartsExportData(Highcharts);

import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface IProps {
  isLoading?: boolean;
  title?: string;
  data: any;
  options: any;
  // labels: string[];
  // datasets: { label: string; data: number[]; backgroundColor?: string }[];
}

// interface IProps {
//   isLoading?: boolean;
//   options: Highcharts.Options;
//   title?: string;
// }

const BarChart = ({ isLoading, title, data, options }: IProps) => {
  // const chartRef = useRef<HighchartsReactRefObject | null>(null);
  // useEffect(() => {
  //   if (chartRef.current) {
  //     if (props.isLoading) {
  //       chartRef.current.chart.showLoading();
  //     } else {
  //       chartRef.current.chart.hideLoading();
  //     }
  //   }
  // }, [props.isLoading]);

  useEffect(() => {
    if (isLoading) {
      console.log('Loading chart data...');
    }
  }, [isLoading]);

  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: 'top' as const,
  //     },
  //     title: {
  //       display: !!title,
  //       text: title,
  //     },
  //   },
  // };

  // const data = {
  //   labels,
  //   datasets: datasets.map((d) => ({
  //     ...d,
  //     backgroundColor: d.backgroundColor || '#3498db',
  //     borderRadius: 8,
  //   })),
  // };
  return (
    <>
      <div className="col-md-8 order-md-1 order-2">
        <div className="box-view h-100">
          <div className="d-flex align-items-center">
            {title && <h3 className="box-title">{title}</h3>}
          </div>
          {isLoading ? (
            <p>Loading...</p>
          ) : (
            <>
              <Bar data={data} options={options} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BarChart;
